import { optionForGroupDengueRider } from '../../../../../../data/group-insurance';
import { Checked } from '../../../../../../assets/icon/svg';

interface Props {
    amount: number;
    isPreview: boolean | undefined;
    rider_id: number;
    onChange: (fAmount: number) => void;
}

export default function CheckboxRiderGDR({ amount, isPreview, rider_id, onChange }: Props) {
    return (
        <div className="flex w-full flex-col gap-1">
            {optionForGroupDengueRider.map((option) => {
                const isChecked = amount === option.fAmount;
                return (
                    <label
                        key={option.id}
                        className={`flex w-full cursor-pointer items-center gap-2 whitespace-nowrap rounded border p-2 transition-all duration-200 ${isPreview ? "border-none" : isChecked ? "border-gray-300 bg-[#186cb2]/10" : "border-gray-200 bg-white hover:border-[#186cb2] hover:bg-gray-50"}`}
                    >
                        <input
                            type="radio"
                            name={`group-dengue-${rider_id}`}
                            checked={isChecked}
                            className="hidden"
                            disabled={isPreview}
                            onChange={() => onChange(option.fAmount)}
                        />
                        <div className={`flex h-3.5 w-3.5 shrink-0 items-center justify-center rounded-full border transition ${isChecked ? "border-[#186cb2] bg-[#186cb2]" : "border-gray-400 bg-white"}`}>
                            {isChecked && <Checked />}
                        </div>
                        <span className="text-xs text-black">{option.label}</span>
                    </label>
                );
            })}
        </div>
    );
}